var classes = function (base, additional) {
    if (!additional) {
        return base;
    }
    if (typeof additional === 'string') {
        return "".concat(base, " ").concat(additional);
    }
    return "".concat(base, " ").concat(additional.join(' '));
};
export default classes;
